import { Map } from 'immutable';
import actions from './actions';

const initialState = new Map({

  // propertyData
  loadingPropertyDetails: false,
  propertyDetails: {},
  loadingPropertyDetailsFailedData: {},

  // invitedTenants
  loadingInvitedTenants: false,
  invitedTenants: {},
  loadingInvitedTenantsFailedData: {},

  // createAST
  creatingAst: false,
  creatingAstSuccessData: {},
  creatingAstFailedData: {},

  // getAST
  loadingAst: false,
  astData: {},
  loadingAstFailedData: {},

  // listTaAgreements
  loadingTaAgreements: false,
  taAgreements: [],
  loadingTaAgreementsFailedData: {},

  // updateAST
  updatingAst: false,
  updatingAstSuccessData: {},
  updatingAstFailedData: {},

  // delete AST
  deletingAst: false,
  deletingAstSuccessData: {},
  deletingAstFailedData: {},

  // sign AST
  signingAst: false,
  signingAstSuccessData: {},
  signingAstFailedData: {},

  // tenancyAgreementData
  taData: {
    // agreementId: 1,
    agreementText: null,
    completed: 0,
    completedNotificationSent: 0,
    // dateCompleted: null,
    // dateCompletedNotificationSent: null,
    // dateLanlordSigned: null,
    dateStart: {},
    // dateTenantSigned: null,
    depositAmount: "0",
    depositHeldBy: null,
    depositScheme: null,
    durationMonths: 0,
    durationYears: 0,
    guarantor: 0,
    guarantorAddress1: null,
    guarantorAddress2: null,
    guarantorAddress3: null,
    guarantorAddress4: null,
    guarantorEmail: null,
    guarantorFirstname: null,
    guarantorLastname: null,
    guarantorPostcode: null,
    // hash: "02c8d87e71543195b24a5dcb92cd525f",
    // id: 166,
    landlordAddress1: null,
    landlordAddress2: null,
    landlordAddress3: null,
    landlordAddress4: null,
    landlordFirstname: null,
    // landlordId: 405,
    landlordLastname: null,
    landlordOrganisationName: null,
    letAsOrganisation: 0,
    landlordPostcode: null,
    leadTenantId: null,
    optionParkingSpace: 0,
    optionPetsAllowed: 0,
    // optionText: null,
    propertyId: null,
    rentAmount: "0",
    rentMonthDay: 0,
    // rentalstepReference: "ASTRS100166",
    // replaceValues: null,
    // setupCompleted: 0,
    // slots: "2",
    // slotsComoplete: "0",
    // status: "0",
    tenantAddress1: null,
    tenantAddress2: null,
    tenantAddress3: null,
    tenantAddress4: null,
    tenantEmail: null,
    tenantFirstname: null,
    tenantId: null,
    tenantIdList: "[]",
    tenantLastname: null,
    tenantPostcode: null,
  }
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    // DO_GET_PROPERTY
    case actions.DO_GET_PROPERTY:
      return state
        .set('loadingPropertyDetails', true);
    case actions.DO_GET_PROPERTY_SUCCESS:
      return state
        .set('loadingPropertyDetails', false)
        .set('propertyDetails', action.payload)
        .set('loadingPropertyDetailsFailedData', {});
    case actions.DO_GET_PROPERTY_FAILED:
      return state
        .set('loadingPropertyDetails', false)
        .set('propertyDetails', {})
        .set('loadingPropertyDetailsFailedData', action.payload);

    // DO_GET_INVITED_TENANTS
    case actions.DO_GET_INVITED_TENANTS:
      return state
        .set('loadingInvitedTenants', true);
    case actions.DO_GET_INVITED_TENANTS_SUCCESS:
      return state
        .set('loadingInvitedTenants', false)
        .set('invitedTenants', action.payload)
        .set('loadingInvitedTenantsFailedData', {});
    case actions.DO_GET_INVITED_TENANTS_FAILED:
      return state
        .set('loadingInvitedTenants', false)
        .set('invitedTenants', {})
        .set('loadingInvitedTenantsFailedData', action.payload);

    // DO_CREATE_AST
    case actions.DO_CREATE_AST:
      return state
        .set('creatingAst', true);
    case actions.DO_CREATE_AST_SUCCESS:
      return state
        .set('creatingAst', false)
        .set('creatingAstSuccessData', action.payload)
        .set('creatingAstFailedData', {});
    case actions.DO_CREATE_AST_FAILED:
      return state
        .set('creatingAst', false)
        .set('creatingAstSuccessData', {})
        .set('creatingAstFailedData', action.payload);

    // DO_GET_AST
    case actions.DO_GET_AST:
      return state
        .set('loadingAst', true);
    case actions.DO_GET_AST_SUCCESS:
      // save a copy of ast data to populate forms and manipulate
      // if some details are missing, we can get this from different
      // parts of the response
      const { ast, document, leadTenant, landlord, property, organisation } = action.payload;
      const taData = { ...ast };
      // get names of landlord & tenant
      if (!taData.landlordFirstname)
        taData.landlordFirstname = landlord.firstname;
      if (!taData.landlordLastname)
        taData.landlordLastname = landlord.lastname;
      if (!taData.tenantFirstname)
        taData.tenantFirstname = leadTenant.firstname;
      if (!taData.tenantLastname)
        taData.tenantLastname = leadTenant.lastname;
      if (!taData.landlordOrganisationName && organisation) {
        taData.landlordOrganisationName = organisation.organisationName;
      }
      return state
        .set('loadingAst', false)
        .set('astData', action.payload)
        .set('taData', taData)
        .set('loadingAstFailedData', {});
    case actions.DO_GET_AST_FAILED:
      return state
        .set('loadingAst', false)
        .set('astData', {})
        .set('loadingAstFailedData', action.payload);

    // DO_LIST_TA_AGREEMENTS
    case actions.DO_LIST_TA_AGREEMENTS:
      return state
        .set('loadingTaAgreements', true);
    case actions.DO_LIST_TA_AGREEMENTS_SUCCESS:
      return state
        .set('loadingTaAgreements', false)
        .set('taAgreements', action.payload)
        .set('loadingTaAgreementsFailedData', {});
    case actions.DO_LIST_TA_AGREEMENTS_FAILED:
      return state
        .set('loadingTaAgreements', false)
        .set('taAgreements', {})
        .set('loadingTaAgreementsFailedData', action.payload);

    // DO_UPDATE_AST
    case actions.DO_UPDATE_AST:
      return state
        .set('updatingAst', true);
    case actions.DO_UPDATE_AST_SUCCESS:
      return state
        .set('updatingAst', false)
        .set('updatingAstSuccessData', action.payload)
        .set('updatingAstFailedData', {});
    case actions.DO_UPDATE_AST_SUCCESS:
      return state
        .set('updatingAst', false)
        .set('updatingAstSuccessData', {})
        .set('updatingAstFailedData', action.payload);

    // DO_DELETE_AST
    case actions.DO_DELETE_AST:
      return state
        .set('deletingAst', true);
    case actions.DO_DELETE_AST_SUCCESS:
      return state
        .set('deletingAst', false)
        .set('deletingAstSuccessData', action.payload)
        .set('deletingAstFailedData', {});
    case actions.DO_DELETE_AST_SUCCESS:
      return state
        .set('deletingAst', false)
        .set('deletingAstSuccessData', {})
        .set('deletingAstFailedData', action.payload);

    // DO_SIGN_AST
    case actions.DO_SIGN_AST:
      return state
        .set('signingAst', true);
    case actions.DO_SIGN_AST_SUCCESS:
      return state
        .set('signingAst', false)
        .set('signingAstSuccessData', action.payload)
        .set('signingAstFailedData', {});
    case actions.DO_SIGN_AST_SUCCESS:
      return state
        .set('signingAst', false)
        .set('signingAstSuccessData', {})
        .set('signingAstFailedData', action.payload);

    // DO_UPDATE_TA_DATA
    case actions.DO_UPDATE_TA_DATA:
      const newTaData = Object.assign({}, state.get('taData'), action.payload);
      return state
        .set('taData', newTaData);

    case actions.DO_CLEAR_TA_DATA:
      return state
        .set('taData', {})
        .set('updatingAstSuccessData', {})
        .set('updatingAstFailedData', {})
        .set('creatingAstSuccessData', {})
        .set('creatingAstFailedData', {})

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/propertiesTenancyAgreements/reducer.js